import React from "react";
import { map } from "lodash";
import {
  StepperContainer,
  Container,
  Step,
  LabelContainer,
} from "./styled-components";
import Text from "../text";

const Stepper = ({ activeStep, steps }: StepperProps) => {
  return (
    <StepperContainer>
      {map(steps, ({ value, label }, index) => {
        return (
          <Container key={index}>
            <Step isActive={activeStep === value}>{value}</Step>
            <LabelContainer isActive={activeStep === value}>
              <Text size="18px">{label}</Text>
            </LabelContainer>
          </Container>
        );
      })}
    </StepperContainer>
  );
};

export default Stepper;
